import { PortfolioChartContainer } from './PortfolioChartContainer';

export const PortfolioChart = PortfolioChartContainer;
